function headerSearchIcon() {
  let $searchContainers = document.querySelectorAll('[data-js="search-container"]');
  if (!$searchContainers) return;

  Array.from($searchContainers).forEach($searchContainer => {

    let $searchIcon = $searchContainer.querySelector('[data-js="search-icon"]');
    let $searchForm = $searchContainer.querySelector('[data-js="search-form"]');

    if (!$searchIcon || !$searchForm) return;

    $searchIcon.addEventListener('click', () => {
      $searchForm.classList.toggle('active');
    });

    /* $searchContainer.addEventListener('mouseleave', () => {
       $searchForm.classList.remove('active');
    }); */
  });
}

headerSearchIcon();